import { motion } from "framer-motion";
import { Star } from "lucide-react";

const testimonials = [
  {
    name: "Sunita D.",
    text: "Dr. Neha Agarwal guided us through a very difficult time with clarity and confidence. Her expertise and compassionate care made all the difference.",
    rating: 5,
    location: "Kolkata",
  },
  {
    name: "Priya M.",
    text: "I was terrified after my diagnosis, but Dr. Agarwal explained every step of the treatment plan clearly. She is not just a brilliant doctor but a wonderful human being.",
    rating: 5,
    location: "Howrah",
  },
  {
    name: "Anjali R.",
    text: "The surgery went smoothly and the recovery was much faster than expected. Dr. Neha's team was supportive throughout. Highly recommend her for gynecologic oncology.",
    rating: 5,
    location: "Salt Lake",
  },
  {
    name: "Meera S.",
    text: "After consulting multiple doctors, Dr. Neha Agarwal was the one who gave us hope and a clear path forward. Her knowledge and empathy are truly remarkable.",
    rating: 5,
    location: "Burdwan",
  },
];

export default function TestimonialsSection() {
  return (
    <section
      id="testimonials"
      data-testid="testimonials-section"
      className="py-24 md:py-32 bg-[#F9F9F6]"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-24">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.6 }}
          className="mb-14"
        >
          <p className="text-sm font-semibold tracking-[0.2em] uppercase text-[#8FA998] mb-4">
            Patient Stories
          </p>
          <h2
            data-testid="testimonials-heading"
            className="font-serif text-4xl sm:text-5xl tracking-tight text-[#1E3F33] leading-tight max-w-2xl"
          >
            What Patients Say
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {testimonials.map((t, i) => (
            <motion.div
              key={t.name}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.5, delay: i * 0.1 }}
              data-testid={`testimonial-card-${i}`}
              className="bg-[#F2EFE9] rounded-2xl md:rounded-[2rem] p-7 md:p-8 flex flex-col justify-between hover:-translate-y-1 hover:shadow-xl hover:shadow-[#1E3F33]/5 transition-all duration-300"
            >
              <div>
                <div className="flex gap-1 mb-5" data-testid={`testimonial-stars-${i}`}>
                  {Array.from({ length: t.rating }).map((_, j) => (
                    <Star key={j} className="w-4 h-4 fill-[#C29F60] text-[#C29F60]" />
                  ))}
                </div>
                <p className="font-serif text-lg sm:text-xl text-[#1E3F33] italic leading-relaxed mb-6">
                  "{t.text}"
                </p>
              </div>
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 rounded-full bg-[#1E3F33]/10 flex items-center justify-center">
                  <span className="font-serif text-lg text-[#1E3F33] font-semibold">
                    {t.name.charAt(0)}
                  </span>
                </div>
                <div>
                  <p className="text-sm font-semibold text-[#1E3F33]">{t.name}</p>
                  <p className="text-xs text-[#4A6359]">{t.location}</p>
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
